<template>
    <!-- Header -->
    <div class="tw:fixed tw:left-4 tw:right-4 tw:h-[60px] tw:z-[999] tw:rounded-2xl tw:border tw:transition-all tw:duration-300 tw:flex tw:items-center tw:justify-between tw:gap-2 tw:sm:gap-3 tw:px-3 tw:sm:px-4"
        :class="[sidebarCollapsed ? 'tw:lg:left-24' : 'tw:lg:left-74', scrolled ? 'tw:top-0! tw:bg-primary! tw:border-transparent! tw:shadow-lg!' : 'tw:top-4 tw:bg-white tw:border-gray-200 tw:shadow-sm']">
        <div class="tw:flex tw:items-center tw:gap-3">
            <!-- Escritorio: colapsa/expande el sidebar. Móvil: abre/cierra el drawer -->
            <button type="button" aria-label="Menú"
                class="tw:inline-flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:border-0 tw:bg-transparent tw:cursor-pointer tw:transition-colors"
                :class="scrolled ? 'tw:text-white! tw:hover:bg-white/10!' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'"
                @click="toggleSidebarResponsive">
                <i class="fas fa-align-left"></i>
            </button>
        </div>

        <ul class="tw:flex tw:items-center tw:gap-2 tw:sm:gap-3 tw:list-none tw:m-0 tw:p-0">
            <li>
                <a :href="`http://www.academia.aliht.com.mx?token=${$authToken}`" target="_blank"
                    class="tw:inline-flex tw:items-center tw:justify-center tw:px-3 tw:py-1.5! tw:text-xs tw:font-semibold tw:text-white tw:bg-primary tw:rounded-lg tw:shadow-sm tw:transition-opacity tw:hover:opacity-90 tw:no-underline"
                    :class="scrolled ? 'tw:bg-brand-background! tw:text-white! tw:hover:bg-white/10!' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'"
                    title="Academia">
                    <i class="fas fa-graduation-cap tw:sm:hidden"></i>
                    <span class="tw:hidden tw:sm:inline">Academia</span>
                </a>
            </li>

            <!-- Notifications -->
            <li>
                <BaseDropdown width="tw:w-80 tw:max-w-[calc(100vw-1rem)]">
                    <template #trigger="{ open, toggle }">
                        <button type="button" aria-haspopup="menu" :aria-expanded="open ? 'true' : 'false'"
                            class="tw:relative tw:inline-flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded-lg tw:border-0 tw:bg-transparent tw:cursor-pointer tw:transition-colors"
                            :class="scrolled ? 'tw:text-white! tw:hover:bg-white/10!' : 'tw:text-slate-500 tw:hover:bg-slate-100 tw:hover:text-slate-800'"
                            @click="toggle">
                            <i class="far fa-bell"></i>
                            <span v-if="totalNotification > 0"
                                class="tw:absolute tw:top-1 tw:right-1 tw:w-2.5 tw:h-2.5 tw:bg-red-500 tw:rounded-full tw:border-2 tw:border-white"></span>
                        </button>
                    </template>

                    <div
                        class="tw:flex tw:items-center tw:justify-between tw:px-3 tw:py-2 tw:mb-1 tw:border-b tw:border-slate-100">
                        <span class="tw:text-sm tw:font-semibold tw:text-slate-700">Notificaciones ( {{
                            totalNotification }} )</span>
                        <a v-if="totalNotification > 0"
                            class="tw:text-xs tw:text-primary tw:cursor-pointer tw:font-medium tw:hover:underline"
                            @click="clearAllNotifications()"> Limpiar todo </a>
                    </div>
                    <BaseDropdownItem v-for="item in notifications" :key="'noti' + item.id"
                        :to="`${item.data.url}?notification=${item.id}`" @click="getNotifications()">
                        <span class="tw:flex tw:items-center tw:gap-3">
                            <span class="tw:shrink-0 tw:w-8 tw:h-8 tw:rounded-full tw:overflow-hidden tw:bg-slate-100">
                                <img class="tw:w-full tw:h-full tw:object-cover tw:rounded-full" alt=""
                                    :src="item.data.icon">
                            </span>
                            <span class="tw:block tw:min-w-0">
                                <span class="tw:block tw:text-xs tw:font-medium tw:text-slate-700 tw:truncate">
                                    {{ item.data.title }}
                                </span>
                                <span class="tw:block tw:text-[11px] tw:font-normal tw:text-slate-400 tw:mt-0.5">
                                    {{ item.data.date | date_format_time }}
                                </span>
                            </span>
                        </span>
                    </BaseDropdownItem>
                    <div class="tw:px-3 tw:py-2 tw:mt-1 tw:border-t tw:border-slate-100 tw:text-center">
                        <a class="tw:text-xs tw:text-primary tw:cursor-pointer tw:font-medium tw:hover:underline"
                            @click="getNotifications()">Actualizar</a>
                    </div>
                </BaseDropdown>
            </li>
            <!-- /Notifications -->

            <!-- User Menu -->
            <li>
                <BaseDropdown>
                    <template #trigger="{ open, toggle }">
                        <button type="button" aria-haspopup="menu" :aria-expanded="open ? 'true' : 'false'"
                            class="tw:inline-flex tw:items-center tw:border-0 tw:bg-transparent tw:cursor-pointer tw:p-0"
                            @click="toggle">
                            <img class="tw:rounded-full tw:w-9 tw:h-9 tw:object-cover tw:border tw:border-slate-200"
                                :src="user.avatar_url" alt="Admin">
                        </button>
                    </template>

                    <BaseDropdownItem icon="fa fa-user" to="/admin/perfil">Mi perfil</BaseDropdownItem>
                    <BaseDropdownItem icon="fa fa-cog" to="/admin/configuracion">Configuración de sistema
                    </BaseDropdownItem>
                    <BaseDropdownItem icon="fa fa-chart-bar" to="/admin/reporte-agencias">Reporte agencias
                    </BaseDropdownItem>
                    <BaseDropdownItem icon="fa fa-external-link-alt"
                        :href="`https://aliht.com.mx/?authToken=${$authToken}`" target="_blank">
                        Editar Landing Page
                    </BaseDropdownItem>
                    <BaseDropdownItem icon="fa fa-external-link-alt"
                        :href="`https://souvenirs.aliht.com.mx/?authToken=${$authToken}`" target="_blank">
                        Control de Souvenirs
                    </BaseDropdownItem>
                    <div class="tw:my-1 tw:border-t tw:border-slate-100"></div>
                    <BaseDropdownItem icon="fa fa-sign-out-alt" variant="danger" @click="logout()">
                        Cerrar sesión
                    </BaseDropdownItem>
                </BaseDropdown>
            </li>
            <!-- /User Menu -->
        </ul>
    </div>
    <!-- /Header -->
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { ROUTE_LOGIN } from "@/enums/RouteNameEnums";
import { toggleSidebarResponsive, isSidebarEffectivelyCollapsed } from '@/plugins/sidebarStore';

export default {
    name: 'TopBar',
    data() {
        return {
            config: {},
            notifications: [],
            totalNotification: 0,
            scrolled: false,
        }
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        sidebarCollapsed() {
            return isSidebarEffectivelyCollapsed();
        },
    },
    created() {
        this.getNotifications();

        window.Push.Permission.request();
        window.Echo.private(`App.Models.User.1`)
            .notification((notification) => {
                if (notification.icon) {
                    window.Push.create(notification.title, {
                        body: notification.body,
                        link: notification.url,
                        icon: notification.icon,
                        onClick: function () {
                            window.location.href = notification.url;
                            this.close();
                        }
                    });
                }
                this.getNotifications();
            });
    },
    mounted() {
        setTimeout(() => {
            const config = JSON.parse(localStorage.getItem('configuration'));
            if (config !== undefined && config !== null) {
                this.config = config;
            }
        }, 2000);

        this.scrollContainer = document.getElementById('page-scroll');
        if (this.scrollContainer) {
            this.scrollContainer.addEventListener('scroll', this.handleScroll);
        }
    },
    beforeDestroy() {
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', this.handleScroll);
        }
    },
    methods: {
        ...mapActions("auth", ["sendLogoutRequest"]),
        toggleSidebarResponsive,
        handleScroll() {
            this.scrolled = this.scrollContainer.scrollTop >= 30;
        },
        logout() {
            this.sendLogoutRequest();
            setTimeout(() => {
                this.$router.push({ name: ROUTE_LOGIN });
            }, 1500);

        },
        getNotifications() {
            fetch(`${this.$baseUrl}/api/admin/notifications`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem("authToken")}`
                },
            })
                .then(response => response.json())
                .then(data => {
                    this.notifications = data.data;
                    this.totalNotification = data.count;
                })
                .catch(error => {
                    console.error('Error en la fetch:', error);
                });
        },
        clearAllNotifications() {
            this.$axios
                .post(`${this.$baseUrl}/api/admin/notifications-clear-all`, {
                    '_method': 'PUT'
                })
                .then(response => {
                    this.getNotifications();
                })
                .catch((e) => {
                    this.$store.commit("setErrors", e);
                });
        },
    }
}
</script>
